import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';

export function PreviewEndModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(8px)',
          animation: 'fadeIn 0.4s ease',
          '@keyframes fadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '440px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          outline: 'none',
          animation: 'slideIn 0.4s ease',
          '@keyframes slideIn': {
            from: { 
              opacity: 0, 
              transform: 'scale(0.9) translateY(20px)' 
            },
            to: { 
              opacity: 1, 
              transform: 'scale(1) translateY(0)' 
            },
          },
        }}
      >
        <Typography
          sx={{
            color: '#4a5568',
            lineHeight: 1.7,
            mb: '24px',
            fontSize: '15px',
            textAlign: 'center',
            px: '16px',
          }}
        >
          Your preview period has ended. Please upgrade to continue using all features.
        </Typography>
        <Button
          variant="outlined"
          onClick={onClose}
          fullWidth
          sx={{
            color: '#667eea',
            border: '2px solid #667eea',
            py: '13px',
            borderRadius: '12px',
            fontWeight: 600,
            textTransform: 'none',
            fontSize: '15px',
            letterSpacing: '0.2px',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: '#667eea',
              color: '#fff',
              border: '2px solid #667eea',
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
            },
            '&:active': {
              transform: 'translateY(0px)',
            },
          }}
        >
          Okay
        </Button>
      </Box>
    </Modal>
  );
}